module.exports = __webpack_public_path__ + "3ce12f88b4c9b91cbdc7040945fb0f96.svg";